/* import __COLOCATED_TEMPLATE__ from './pin-icon.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-management */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Args: any;
}

const PinIcon = templateOnlyComponent<Signature>();
export default PinIcon;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationsTable::Icons::PinIcon': typeof PinIcon;
    'inbox2/conversations-table/icons/pin-icon': typeof PinIcon;
  }
}
